export class DeviceAvailability {
    IsDesktop: boolean;
    IsMobile: boolean;
    IsTablet: boolean;

    constructor(source: DeviceAvailability) {
        this.IsDesktop = source.IsDesktop;
        this.IsMobile = source.IsMobile;
        this.IsTablet = source.IsTablet;
    }
}